
import request from '@/utils/request'

export default {
  /****文件上传  Api */
  //文件上传，附件格式fileType：1-图片，2-录音 3-短信
  agentManagePage:(data,fileData)=>{
    return request({
      url: `/minio/upload?type=${data.type}&fileType=${data.fileType}&name=${data.name}&orderId=${data.orderId}`,
      method: 'post',
      data:fileData
    })
  },
  //获取附件列表
  minioGetList:(data)=>{
    return request({
      url: `/minio/getList`,
      method: 'post',
      data:data
    })
  },
  //通过手机验证码修改密码
  merchantUpdatePasswordNew:(data)=>{
    return request({
      url: `/merchant/admin/updatePasswordNew`,
      method: 'post',
      data:data
    })
  },
  //获取验证码 type-短信类型 1-绑定手机 2-注册/登录 3-修改密码
  merchantGetAuthCode:(data)=>{
    return request({
      url: `/merchant/admin/getAuthCode`,
      method: 'get',
      params:data
    })
  },

  
  //修改指定用户密码
  updatePassword:(data)=>{
    return request({
      url: `/admin/updatePassword`,
      method: 'post',
      data:data
    })
  },

  
  //百度验证二要素    姓名+ 手机号
  telecomApi:(data)=>{
    return request({
      url: `/order/telecomApi`,
      method: 'post',
      data:data
    })
  },
  
  // 查询代还金额
  queryAmt:(data)=>{
    return request({
      url: `/orderLoan/queryAmt/${data.orderId}`,
      method: 'POST',
      data:{}
    })
  },

  
  // 客户提交企微投诉
  feedback:(data)=>{
    return request({
      url: `https://gatetest.efenda.cn/mall-portal/sso/feedback`,
      method: 'POST',
      data:data
    })
  },


  
  // 清理登录缓存
  clearUserCache:(phone)=>{
    return request({
      url: `/member/clearUserCache?phone=${phone}`,
      method: 'post',
      data:{}
    })
  },
}



// WEBPACK FOOTER //
// ./src/api/baseApi.js